import { useCallDetailsCaller } from 'features/call/call-details/hooks';
import { CallDetailsNewCall } from 'features/call/call-details/components';

export const CallDetailsNewCallContainer = () => {
  const { caller } = useCallDetailsCaller();

  return <CallDetailsNewCall caller={caller} />;
};
